import React from "react";
import bgImg from "../../src/image/bgImg.jpg"

const backgroundImage = bgImg;

const LearningMethod = () => {
  const cards = [
    {
      title: "Expert-Led Recorded Video Training ",
      description:
        "Learn through structured, self-paced lessons designed by industry experts.",
    },
    {
      title: "Practical Assignments & Real-World Projects ",
      description:
        "Apply concepts through hands-on exercises and business-focused projects.",
    },
    {
      title: "Weekly Live Doubt-Clearing Sessions",
      description:
        "Get guidance, clarification, and mentorship from experienced trainers.",
    },
    {
      title: "AI-Powered LMS & Lifetime Access ",
      description:
        "Access learning resources anytime, track your progress, and revisit content whenever needed",
    },
  ];
  return (
    <section className="bg-white w-full overflow-x-hidden relative mb-0 pb-0">
      {/* Heading and Subheading */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-12 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div
  className="
    font-[Figtree]
    font-semibold

    text-[34px]
    sm:text-[42px]
    lg:text-[55px]

    leading-[150%]

    tracking-[-0.03em]

    text-center

    text-[#02054C]

    mb-6
  "
>
  Learning <br />
  Methodology
</div>

        <p className="font-[Figtree] font-medium text-[20px] leading-[1.5] tracking-[-0.04em] text-[#818285] mt-6 md:mt-0 max-w-md lg:text-right">
          Our teaching approach is built to balance flexibility, interaction,
          and results—ensuring you gain both knowledge and confidence.
        </p>
      </div>

      {/* Cards container - positioned above bgImg */}
      <div className="relative z-10 w-full max-w-7xl mx-auto mb-0 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
          {cards.map(({ title, description }, i) => (
            <div
              key={i}
              className="relative bg-white rounded-lg p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 w-full group"
              style={{ backdropFilter: "saturate(180%) blur(20px)" }}
            >
              {/* Glow effect */}
              <div className="absolute inset-0 rounded-lg bg-gradient-to-br from-blue-100/30 to-purple-100/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 blur-md"></div>

              <h3 className="p-3 font-figtree font-semibold text-[30px] leading-[1.1] tracking-[-0.04em] text-[#1E1E1E] mb-3">
                {title}
              </h3>

              <p className="px-3 font-figtree font-medium text-[19px] leading-[1.5] tracking-[-0.04em] text-[#1E1E1E]">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Background Image - behind cards; less pull-up on mobile so faces stay visible */}
      <div className="max-w-[1500px] m-auto h-[350px] sm:h-[450px] md:h-[600px] lg:h-[676px] -mt-10 sm:-mt-16 md:-mt-28 lg:-mt-32 mb-0 relative z-0">
        {/* Glow effect from cards overlapping the bgImg */}
        <div className="absolute -top-16 left-0 right-0 h-16 bg-gradient-to-b from-blue-100/20 to-transparent pointer-events-none"></div>

        <div
          className="w-full h-full bg-cover bg-no-repeat bg-[center_22%] md:bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />
      </div>
    </section>
  );
};

export default LearningMethod;
